import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import { setItemInStorage, getItemFromStorage, removeItemInStorage } from 'commons/localStorage';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useCart from '../useCart';
import { PDP_EXTRA_CUSHION } from '../../commons/constants';
const usePDPExtraCushion = () => {
  const $ = _c(36);
  const {
    loading,
    error,
    data: productDetails
  } = usePDPBasicDetails();
  const {
    loading: optionsLoading,
    error: optionsError,
    data: optionsData
  } = usePDPOptions();
  const {
    loading: cartLoading,
    data: t0
  } = useCart();
  const {
    cart
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [priceObj, setPriceObj] = useState(t1);
  const [isAdded, setIsAdded] = useState(false);
  const [optionValueId, setOptionValueId] = useState(false);
  let t2;
  if ($[1] !== optionsData?.options || $[2] !== productDetails) {
    t2 = () => {
      const getItem = () => {
        if (productDetails?.id) {
          return getItemFromStorage(`${PDP_EXTRA_CUSHION}:${productDetails.id}`);
        }
        return null;
      };
      if (!productDetails?.id || !optionsData?.options) {
        return;
      }
      let cost = 0;
      let valueId;
      const cushion = optionsData?.options.find(_temp);
      if (cushion?.values) {
        cushion.values.forEach(v => {
          if (v.additional_cost > 0) {
            valueId = v.id;
            cost = v.additional_cost;
          }
        });
        const priceObjCopy = {
          ...productDetails?.meta?.price
        };
        priceObjCopy.original_price = cost;
        if (cost) {
          setPriceObj(priceObjCopy);
        }
        if (valueId) {
          setOptionValueId(valueId);
        }
      }
      if (getItem()) {
        setIsAdded(true);
      }
    };
    $[1] = optionsData?.options;
    $[2] = productDetails;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = optionsData?.options;
  const t4 = productDetails?.id;
  const t5 = productDetails?.meta?.price;
  let t6;
  if ($[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t6 = [t3, t4, t5];
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  useEffect(t2, t6);
  let t7;
  if ($[8] !== cartLoading || $[9] !== productDetails) {
    t7 = () => {
      const getItem_0 = () => {
        if (productDetails?.id) {
          return getItemFromStorage(`${PDP_EXTRA_CUSHION}:${productDetails.id}`);
        }
        return null;
      };
      if (!cartLoading) {
        setIsAdded(!!getItem_0());
      }
    };
    $[8] = cartLoading;
    $[9] = productDetails;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = productDetails?.id;
  let t9;
  if ($[11] !== cart || $[12] !== cartLoading || $[13] !== t8) {
    t9 = [cart, cartLoading, t8];
    $[11] = cart;
    $[12] = cartLoading;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  useEffect(t7, t9);
  let t10;
  if ($[15] !== productDetails) {
    t10 = val => {
      if (productDetails?.id) {
        setItemInStorage(`${PDP_EXTRA_CUSHION}:${productDetails.id}`, val);
      }
    };
    $[15] = productDetails;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const setItem = t10;
  let t11;
  if ($[17] !== productDetails) {
    t11 = () => {
      if (productDetails?.id) {
        removeItemInStorage(`${PDP_EXTRA_CUSHION}:${productDetails.id}`);
      }
    };
    $[17] = productDetails;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const removeItem = t11;
  let t12;
  if ($[19] !== optionValueId || $[20] !== setItem) {
    t12 = () => {
      setItem(optionValueId);
      setIsAdded(true);
    };
    $[19] = optionValueId;
    $[20] = setItem;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const onAdd = t12;
  let t13;
  if ($[22] !== removeItem) {
    t13 = () => {
      removeItem();
      setIsAdded(false);
    };
    $[22] = removeItem;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const onRemove = t13;
  const t14 = loading || optionsLoading;
  const t15 = error || optionsError;
  const t16 = productDetails?.meta?.promotion;
  let t17;
  if ($[24] !== isAdded || $[25] !== priceObj || $[26] !== t16) {
    t17 = {
      priceObj,
      promotion: t16,
      isAdded
    };
    $[24] = isAdded;
    $[25] = priceObj;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== onAdd || $[29] !== onRemove) {
    t18 = {
      onAdd,
      onRemove
    };
    $[28] = onAdd;
    $[29] = onRemove;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t14 || $[32] !== t15 || $[33] !== t17 || $[34] !== t18) {
    t19 = {
      loading: t14,
      error: t15,
      data: t17,
      actions: t18
    };
    $[31] = t14;
    $[32] = t15;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  return t19;
};
export default usePDPExtraCushion;
function _temp(o) {
  return o.id === 133;
}